import { useEffect } from 'react'
import { Outlet } from 'react-router-dom-v5-compat'

import {
  injectMetaViewportTag,
  removeMetaViewportTag,
} from '@buffer-mono/app-shell/src/exports/Navigator/utils/metaViewport'

const Settings = (): JSX.Element => {
  useEffect(() => {
    injectMetaViewportTag()

    // remove when component unmounts
    // (the rest of app is not ready for responsive UI yet)
    return (): void => {
      removeMetaViewportTag()
    }
  }, [])

  return <Outlet />
}

export default Settings
